import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "relative" }

import LoadingIcon from "@/components/atoms/BaseLoadingIcon.vue";

// Types
import type { SizesKeysType } from "@/types/sizes.type";
import { SizesKeys } from "@/types/sizes.type";
import type { VariantsType } from "./Button";
import {
  variants,
  VariantKeys,
  sizes,
  fontSizes,
  loadingIconSizes,
} from "./Button";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
    id: { default: "Button" },
    variant: { default: VariantKeys.primary },
    size: { default: SizesKeys.default },
    disabled: { type: Boolean, default: false },
    roudness: { type: Boolean, default: false },
    full: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

// Components


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
      _unref(variants)[_ctx.variant].classes,
      _unref(variants)[_ctx.variant].default,
      _unref(sizes)[_ctx.size],
      _unref(fontSizes)[_ctx.size],
      _ctx.roudness && 'rounded-full',
      _ctx.full && 'h-full w-full',
    ]),
    disabled: _ctx.disabled
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(LoadingIcon, {
            key: 0,
            class: _normalizeClass([[_unref(variants)[_ctx.variant].icon, _unref(loadingIconSizes)[_ctx.size]], "absolute inset-0 mx-auto flex justify-center"])
          }, null, 8, ["class"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.loading && 'opacity-0')
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ])
  ], 10, _hoisted_1))
}
}

})